import { useNavigate } from "react-router-dom";
import { env } from "../assets/env";


export default function Start({deviceType}) 
{
      const navigate=useNavigate();


      return <>
            <div className="text-center mt-5 mb-4">
                  <img className="img-fluid" style={{ maxHeight: '200px' }} src='images/logo.png' alt="MyXAcademy" />
            </div>


            <div className="text-center mb-4">
                  <button className="btn px-5 color-changing-border-colorful startPageStartButtonStyle" style={{borderRadius: '10px'}} 
                        onClick={()=>
                        {
                              if(deviceType==='computer') navigate('/home');
                              else window.location.href=env.androidAppDownloadLink;
                        }
                  }>
                        <h2 className="font-weight-bold">Start!</h2>
                  </button>
            </div>


            <div className="d-flex justify-content-center mb-4 px-1">
                  <h4 className="font-weight-bold p-2 rounded-lg text-center" style={{border: '2px solid red', color: 'red', backgroundColor: 'black'}}>Join now to get 20 coins for free!</h4>
            </div>


            <div className="d-flex justify-content-center mb-5">
                  <div className="rounded-lg py-3 px-2 p-sm-3 mx-1 bg-white" style={{maxWidth: '800px'}}>
                        <h4 className="text-center mb-5">
                              <span className="underlined">Welcome to MyXAcademy</span>
                        </h4>
                        <h5 className="mb-4 text-center"><i>Join the most interactive education platform of Bangladesh!</i></h5>
                        <div className="d-flex">
                              <h5 className="mr-2">✅</h5>
                              <h5 className="font-weight-bold">Get direct one-on-one academic help from amazing tutors at cheapest price anytime from anywhere</h5>
                        </div>
                  </div>
            </div>


            <div className="d-flex justify-content-center mb-5">
                  <div className="d-flex justify-content-center flex-column align-items-center rounded-lg p-2 p-sm-3 mx-1" style={{maxWidth: '800px', backgroundColor: 'white'}}>
                        <h5 className="p-1 p-sm-0 font-weight-normal mb-3" style={{width: '100%', maxWidth: '560px'}}>
                              <u>Watch</u>: How to get direct help from tutors with any subject anytime from anywhere:
                        </h5>
                        <iframe
                              src="https://www.youtube.com/embed/Co0_GEBRC2U?si=w3-9NHJBYhWRT1qH"
                              title="(For students) How to get help from tutors with any subject anytime from anywhere:"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                              referrerPolicy="strict-origin-when-cross-origin"
                              allowFullScreen={true}
                              style={{width: '100%', maxWidth: '560px', border: 0}}
                              height={315+150}
                              className="rounded-lg"
                        />
                  </div>
            </div>


            <div className="d-flex justify-content-center mb-5">
                  <div className="rounded-lg px-2 pt-4 pb-2 mx-1 text-center" style={{maxWidth: '800px', backgroundColor: 'white'}}>
                        <h5>Please download the app from Google Play Store on your mobile device to get notification when you receive a message:</h5>
                        <img 
                              width='200px' className="img-fluid c-pointer" src="images/google-play-button.jpg" alt="google-play-button"
                              onClick={()=>window.location.href=env.androidAppDownloadLink}
                        />
                  </div>
            </div>


            <hr className="mb-5 rounded-lg" style={{color: 'red', border: '2px solid black', width: '95%'}} />


            <div className="d-flex justify-content-center" style={{marginBottom: '100px'}}>
                  <div className="rounded-lg px-2 pt-4 pb-2 mx-1 text-center" style={{maxWidth: '800px', backgroundColor: 'white'}}>
                        <h5 className="mb-3 mx-1">Want to join as a tutor? Send us direct message in MyXAcademy facebook page:</h5>
                        <div className="btn btn-primary font-weight-bold mb-4 rounded-pill px-3" onClick={()=>window.open(env.facebookPageLink)}>
                              <i className="fa-brands fa-facebook" /> MyXAcademy Facebook Page
                        </div>
                  </div>
            </div>
      </>
};
